// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ufeG","title":"InfoRow_title__hov2p"};